import { MessageRichCardType } from '../generated/types.js';

function howCuratedWorksRichCard(message) {
  var _a;

  if (((_a = message.parts[0].body.richCard) === null || _a === void 0 ? void 0 : _a.type) === MessageRichCardType.ONBOARDING_HOW_CURATED_WORKS) {
    return message.parts[0].body.richCard;
  } else if (message.parts[0].body.richCardType === MessageRichCardType.ONBOARDING_HOW_CURATED_WORKS && message.parts[0].body.queryVariables && message.parts[0].body.queryVariables.leadId) {
    return {
      __typename: 'HowCuratedWorksRichCard',
      type: MessageRichCardType.ONBOARDING_HOW_CURATED_WORKS,
      leadId: message.parts[0].body.queryVariables.leadId
    };
  } else {
    return undefined;
  }
}
function consumerInterestedInSellableRichCard(message) {
  var _a;

  if (((_a = message.parts[0].body.richCard) === null || _a === void 0 ? void 0 : _a.type) === MessageRichCardType.CONSUMER_INTERESTED_IN_CURATED_ORDER) {
    return message.parts[0].body.richCard;
  } else if (message.parts[0].body.richCardType === MessageRichCardType.CONSUMER_INTERESTED_IN_CURATED_ORDER && message.parts[0].body.queryVariables && message.parts[0].body.queryVariables.expertCuratedOrderId) {
    return {
      __typename: 'InterestedInCuratedOrderRichCard',
      type: MessageRichCardType.CONSUMER_INTERESTED_IN_CURATED_ORDER,
      expertCuratedOrderId: message.parts[0].body.queryVariables.expertCuratedOrderId
    };
  } else {
    return undefined;
  }
}
function contactCollectionRichCard(message) {
  var _a;

  if (((_a = message.parts[0].body.richCard) === null || _a === void 0 ? void 0 : _a.type) === MessageRichCardType.CONTACT_COLLECTION_REQUEST) {
    return message.parts[0].body.richCard;
  } else if (message.parts[0].body.richCardType === MessageRichCardType.CONTACT_COLLECTION_REQUEST && message.parts[0].body.queryVariables && message.parts[0].body.queryVariables.leadId) {
    return {
      __typename: 'ContactCollectionRichCard',
      type: MessageRichCardType.CONTACT_COLLECTION_REQUEST,
      leadId: message.parts[0].body.queryVariables.leadId
    };
  } else {
    return undefined;
  }
}
function newExpertCuratedOrderListRichCard(message) {
  var _a;

  if (((_a = message.parts[0].body.richCard) === null || _a === void 0 ? void 0 : _a.type) === MessageRichCardType.NEW_EXPERT_CURATED_ORDER_LIST) {
    return message.parts[0].body.richCard;
  } else if (message.parts[0].body.richCardType === MessageRichCardType.NEW_EXPERT_CURATED_ORDER_LIST && message.parts[0].body.queryVariables && message.parts[0].body.queryVariables.expertCuratedOrderListActivationId) {
    return {
      __typename: 'NewCuratedOrderListRichCard',
      type: MessageRichCardType.NEW_EXPERT_CURATED_ORDER_LIST,
      expertCuratedOrderListActivationId: message.parts[0].body.queryVariables.expertCuratedOrderListActivationId
    };
  } else {
    return undefined;
  }
}
function newCustomCuratedOrderRichCard(message) {
  var _a;

  if (((_a = message.parts[0].body.richCard) === null || _a === void 0 ? void 0 : _a.type) === MessageRichCardType.NEW_CUSTOM_CURATED_ORDER) {
    return message.parts[0].body.richCard;
  } else if (message.parts[0].type == 'TEMPLATE_CAROUSEL' && (message.parts[0].body.type === 'new-custom-expert-curated-order' || message.parts[0].body.richCardType === MessageRichCardType.NEW_CUSTOM_CURATED_ORDER) && message.parts[0].body.queryVariables && message.parts[0].body.queryVariables.expertCuratedOrderId) {
    return {
      __typename: 'NewCustomCuratedOrderRichCard',
      type: MessageRichCardType.NEW_CUSTOM_CURATED_ORDER,
      expertCuratedOrderId: message.parts[0].body.queryVariables.expertCuratedOrderId
    };
  } else {
    return undefined;
  }
}
function expertJoinedRichCard(message) {
  var _a;

  if (((_a = message.parts[0].body.richCard) === null || _a === void 0 ? void 0 : _a.type) === MessageRichCardType.ONBOARDING_EXPERT_JOINED) {
    return message.parts[0].body.richCard;
  } else if (message.parts[0].body.richCardType === MessageRichCardType.ONBOARDING_EXPERT_JOINED && message.parts[0].body.queryVariables && message.parts[0].body.queryVariables.expertId) {
    return {
      __typename: 'ExpertJoinedRichCard',
      type: MessageRichCardType.ONBOARDING_EXPERT_JOINED,
      expertId: message.parts[0].body.queryVariables.expertId
    };
  } else {
    return undefined;
  }
}
function feedbackRequestedRichCard(message) {
  var _a;

  if (((_a = message.parts[0].body.richCard) === null || _a === void 0 ? void 0 : _a.type) === MessageRichCardType.FEEDBACK_REQUEST_FROM_EXPERT) {
    return message.parts[0].body.richCard;
  } else if (message.parts[0].body.richCardType === MessageRichCardType.FEEDBACK_REQUEST_FROM_EXPERT && message.parts[0].body.queryVariables && message.parts[0].body.queryVariables.expertId && message.parts[0].body.queryVariables.leadId) {
    return {
      __typename: 'ExpertFeedbackRequestRichCard',
      type: MessageRichCardType.FEEDBACK_REQUEST_FROM_EXPERT,
      expertId: message.parts[0].body.queryVariables.expertId,
      leadId: message.parts[0].body.queryVariables.leadId
    };
  } else {
    return undefined;
  }
}
function guestChatCreateRequestRichCard(message) {
  var _a, _b, _c;

  if (((_a = message.parts[0].body.richCard) === null || _a === void 0 ? void 0 : _a.type) === MessageRichCardType.GUEST_CHAT_CREATE_REQUEST) {
    return message.parts[0].body.richCard;
  } else if (message.parts[0].body.richCardType === MessageRichCardType.GUEST_CHAT_CREATE_REQUEST && ((_b = message.parts[0].body.queryVariables) === null || _b === void 0 ? void 0 : _b.categoryId) && ((_c = message.parts[0].body.queryVariables) === null || _c === void 0 ? void 0 : _c.leadId)) {
    return {
      __typename: 'GuestChatCreateRequestRichCard',
      type: MessageRichCardType.GUEST_CHAT_CREATE_REQUEST,
      expertId: message.parts[0].body.queryVariables.expertId,
      categoryId: message.parts[0].body.queryVariables.categoryId
    };
  } else {
    return undefined;
  }
}
function paymentVerificationRequestRichCard(message) {
  var _a, _b, _c;

  if (((_a = message.parts[0].body.richCard) === null || _a === void 0 ? void 0 : _a.type) === MessageRichCardType.PAYMENT_VERIFICATION_REQUEST) {
    return message.parts[0].body.richCard;
  } else if (message.parts[0].body.richCardType === MessageRichCardType.PAYMENT_VERIFICATION_REQUEST && ((_b = message.parts[0].body.queryVariables) === null || _b === void 0 ? void 0 : _b.orderId) && ((_c = message.parts[0].body.queryVariables) === null || _c === void 0 ? void 0 : _c.transactionId)) {
    return {
      __typename: 'PaymentVerificationRequestRichCard',
      type: MessageRichCardType.PAYMENT_VERIFICATION_REQUEST,
      orderId: message.parts[0].body.queryVariables.orderId,
      transactionId: message.parts[0].body.queryVariables.transactionId
    };
  } else {
    return undefined;
  }
}
function newExpertCuratedItemsRichCard(message) {
  var _a, _b;

  if (((_a = message.parts[0].body.richCard) === null || _a === void 0 ? void 0 : _a.type) === MessageRichCardType.NEW_EXPERT_CURATED_ITEMS) {
    return message.parts[0].body.richCard;
  } else if (message.parts[0].body.richCardType === MessageRichCardType.NEW_EXPERT_CURATED_ITEMS && ((_b = message.parts[0].body.queryVariables) === null || _b === void 0 ? void 0 : _b.expertCuratedItemActivationId)) {
    return {
      __typename: 'NewCuratedItemsRichCard',
      type: MessageRichCardType.NEW_EXPERT_CURATED_ITEMS,
      expertCuratedItemActivationId: message.parts[0].body.queryVariables.expertCuratedItemActivationId
    };
  } else {
    return undefined;
  }
}
function newSystemCuratedItemsRichCard(message) {
  var _a, _b;

  if (((_a = message.parts[0].body.richCard) === null || _a === void 0 ? void 0 : _a.type) === MessageRichCardType.NEW_SYSTEM_CURATED_ITEMS) {
    return message.parts[0].body.richCard;
  } else if (message.parts[0].body.richCardType === MessageRichCardType.NEW_SYSTEM_CURATED_ITEMS && ((_b = message.parts[0].body.queryVariables) === null || _b === void 0 ? void 0 : _b.leadId)) {
    return {
      __typename: 'SystemCuratedItemsRichCard',
      type: MessageRichCardType.NEW_SYSTEM_CURATED_ITEMS,
      expertCuratedItemActivationId: message.parts[0].body.queryVariables.expertCuratedItemActivationId
    };
  } else {
    return undefined;
  }
}
function updatedExpertCuratedItemsRichCard(message) {
  var _a, _b;

  if (((_a = message.parts[0].body.richCard) === null || _a === void 0 ? void 0 : _a.type) === MessageRichCardType.UPDATED_EXPERT_CURATED_ITEMS) {
    return message.parts[0].body.richCard;
  } else if (message.parts[0].body.richCardType === MessageRichCardType.UPDATED_EXPERT_CURATED_ITEMS && ((_b = message.parts[0].body.queryVariables) === null || _b === void 0 ? void 0 : _b.expertCuratedItemActivationId)) {
    return {
      __typename: 'UpdatedCuratedItemsRichCard',
      type: MessageRichCardType.UPDATED_EXPERT_CURATED_ITEMS,
      expertCuratedItemActivationId: message.parts[0].body.queryVariables.expertCuratedItemActivationId
    };
  } else {
    return undefined;
  }
}
function systemProductSurveyRichCard(message) {
  var _a;

  if (((_a = message.parts[0].body.richCard) === null || _a === void 0 ? void 0 : _a.type) === MessageRichCardType.SYSTEM_CURATED_ITEM_SURVEY) {
    return message.parts[0].body.richCard;
  } else if (message.parts[0].body.richCardType === MessageRichCardType.SYSTEM_CURATED_ITEM_SURVEY && message.parts[0].body.queryVariables.leadId) {
    return {
      __typename: 'SystemCuratedItemSurveyRichCard',
      type: MessageRichCardType.SYSTEM_CURATED_ITEM_SURVEY,
      leadId: message.parts[0].body.queryVariables.leadId
    };
  } else {
    return undefined;
  }
}
function newExpertCuratedOrderRichCard(message) {
  var _a;

  if (((_a = message.parts[0].body.richCard) === null || _a === void 0 ? void 0 : _a.type) === MessageRichCardType.NEW_BOOKABLE_CURATED_ORDER) {
    return message.parts[0].body.richCard;
  } else if (message.parts[0].body.richCardType === MessageRichCardType.NEW_BOOKABLE_CURATED_ORDER && message.parts[0].body.queryVariables && message.parts[0].body.queryVariables.expertCuratedOrderId) {
    return {
      __typename: 'NewBookableCuratedOrderRichCard',
      type: MessageRichCardType.NEW_BOOKABLE_CURATED_ORDER,
      expertCuratedOrderId: message.parts[0].body.queryVariables.expertCuratedOrderId
    };
  } else {
    return undefined;
  }
}
function simpleExpertCuratedOrderRichCard(message) {
  var _a;

  if (((_a = message.parts[0].body.richCard) === null || _a === void 0 ? void 0 : _a.type) === MessageRichCardType.SIMPLE_CURATED_ORDER) {
    return message.parts[0].body.richCard;
  } else if (message.parts[0].body.richCardType === MessageRichCardType.SIMPLE_CURATED_ORDER && message.parts[0].body.queryVariables && message.parts[0].body.queryVariables.simpleCuratedOrderId) {
    return {
      __typename: 'SimpleCuratedOrderRichCard',
      type: MessageRichCardType.SIMPLE_CURATED_ORDER,
      simpleCuratedOrderId: message.parts[0].body.queryVariables.simpleCuratedOrderId
    };
  } else {
    return undefined;
  }
}
function expertReferralRequestRichCard(message) {
  var _a;

  if (((_a = message.parts[0].body.richCard) === null || _a === void 0 ? void 0 : _a.type) === MessageRichCardType.REFERRAL_REQUEST_FROM_EXPERT) {
    return message.parts[0].body.richCard;
  } else if (message.parts[0].body.richCardType === MessageRichCardType.REFERRAL_REQUEST_FROM_EXPERT && message.parts[0].body.queryVariables && message.parts[0].body.queryVariables.expertId) {
    return {
      __typename: 'ExpertReferralRequestRichCard',
      type: MessageRichCardType.REFERRAL_REQUEST_FROM_EXPERT,
      expertId: message.parts[0].body.queryVariables.leadId
    };
  } else {
    return undefined;
  }
}
function requestConfirmationRichCard(message) {
  var _a;

  if (((_a = message.parts[0].body.richCard) === null || _a === void 0 ? void 0 : _a.type) === MessageRichCardType.ONBOARDING_REQUEST_CONFIRMATION) {
    return message.parts[0].body.richCard;
  } else if (message.parts[0].body.richCardType === MessageRichCardType.ONBOARDING_REQUEST_CONFIRMATION && message.parts[0].body.queryVariables && message.parts[0].body.queryVariables.leadId) {
    return {
      __typename: 'RequestConfirmationRichCard',
      type: MessageRichCardType.ONBOARDING_REQUEST_CONFIRMATION,
      leadId: message.parts[0].body.queryVariables.leadId
    };
  } else {
    return undefined;
  }
}
function requestPriceMatchRichCard(message) {
  var _a, _b;

  if (((_a = message.parts[0].body.richCard) === null || _a === void 0 ? void 0 : _a.type) === MessageRichCardType.SELLABLE_PRICE_MATCH_REQUESTED) {
    return message.parts[0].body.richCard;
  } else if (message.parts[0].body.richCardType === MessageRichCardType.SELLABLE_PRICE_MATCH_REQUESTED && message.parts[0].body.queryVariables && message.parts[0].body.queryVariables.sellableId && // These parts contain the price comparisons
  message.parts[1].body.text && message.parts[2].body.text) {
    // Unlikely, but in the event theres an error with manually entered JSON in the template,
    // we don't want to break rendering for any user forever.
    var priceComparisons = undefined;

    try {
      priceComparisons = message.parts[2].body.text ? JSON.parse(message.parts[2].body.text) : [];
    } catch (e) {}

    return {
      __typename: 'PriceMatchRequestRichCard',
      type: MessageRichCardType.SELLABLE_PRICE_MATCH_REQUESTED,
      sellableId: message.parts[0].body.queryVariables.sellableId,
      price: (priceComparisons === null || priceComparisons === void 0 ? void 0 : priceComparisons.price) || '',
      otherRetailPrices: ((_b = priceComparisons === null || priceComparisons === void 0 ? void 0 : priceComparisons.otherOnlineRetails) === null || _b === void 0 ? void 0 : _b.map(function (value) {
        return {
          retailer: value.retailer,
          price: value.price,
          __typename: 'PriceMatchRequestRetailPrice'
        };
      })) || []
    };
  } else {
    return undefined;
  }
}
function conversationStarterRichCard(message) {
  var _a;

  if (((_a = message.parts[0].body.richCard) === null || _a === void 0 ? void 0 : _a.type) === MessageRichCardType.CONVERSATION_STARTER_SENT) {
    return message.parts[0].body.richCard;
  } else {
    return undefined;
  }
}

export { consumerInterestedInSellableRichCard, contactCollectionRichCard, conversationStarterRichCard, expertJoinedRichCard, expertReferralRequestRichCard, feedbackRequestedRichCard, guestChatCreateRequestRichCard, howCuratedWorksRichCard, newCustomCuratedOrderRichCard, newExpertCuratedItemsRichCard, newExpertCuratedOrderListRichCard, newExpertCuratedOrderRichCard, newSystemCuratedItemsRichCard, paymentVerificationRequestRichCard, requestConfirmationRichCard, requestPriceMatchRichCard, simpleExpertCuratedOrderRichCard, systemProductSurveyRichCard, updatedExpertCuratedItemsRichCard };
//# sourceMappingURL=richCardFactory.js.map
